<div class="header">
  <h1>About GagePeopleMeet</h1>
  <p class="header__lead">
    A deliberately unserious dating experience built around one person who definitely did use a focus group.
  </p>
</div>

<section class="sections" aria-label="About sections">
  <mat-card class="card card--hero">
    <h2 class="card__title">
      <mat-icon class="card__icon">favorite</mat-icon>
      What is this?
    </h2>
    <p class="card__text"> We're not exactly sure either. It is part portfolio piece, part joke, and part sincere attempt to stand out from the crowd.</p>
</mat-card>


  <mat-card class="card">
    <h2 class="card__title">
      <mat-icon aria-hidden="true">person</mat-icon>
      About Gage
    </h2>
    <p class="card__text">
      Online dating is a cesspool of minimum effort, and noncommittal ghosting. Gage is here to shake things up and toe the line between desperate and funny‌‌‌‌‌.
    </p>
    <p class="card__text card__text--muted">
      Want to talk for real? Use Chat in the app, I do actually receive those messages.
    </p>

    <p class="social-intro">Find Gage on Instagram, Snapchat, and OnlyFans </p>
    <div class="social" role="list">
      <a
        mat-stroked-button
        role="listitem"
        class="social__link"
        [href]="gageSocial.instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class="social__logo social__logo--instagram" aria-hidden="true"></span>
        <span>Instagram</span>
      </a>
      <a
        mat-stroked-button
        role="listitem"
        class="social__link"
        [href]="gageSocial.snapchat"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class="social__logo social__logo--snapchat" aria-hidden="true"></span>
        <span>Snapchat</span>
      </a>
      <button
        mat-stroked-button
        type="button"
        role="listitem"
        class="social__link social__link--accent"
        (click)="openOnlyfansGag()"
      >
        <span class="social__logo social__logo--onlyfans" aria-hidden="true"></span>
        <span>OnlyFans 18+</span>
      </button>
    </div>
  </mat-card>

  <mat-card class="card">
    <h2 class="card__title">
      <mat-icon aria-hidden="true">code</mat-icon>
      Definitely Legal and Binding Privacy Statement
    </h2>
    <ul class="bullets bullets--compact">
      <li>I'm not actually storing any of your data.</li>
      <li>Third-party scripts (e.g. Tawk.to) have their own privacy policies when you use chat.</li>
    </ul>
    <mat-divider class="divider" />
    <p class="card__footnote">
      Questions, bugs, or marriage proposals: please route them through the chat.
    </p>
  </mat-card>
</section>
